/**
 * API de auditoría de accesos (lectura).
 */
import { apiFetch } from "./client";

export type AccionAudit = "LEER" | "CREAR" | "MODIFICAR" | "ELIMINAR";

export interface AuditoriaEntry {
  id: number;
  usuario_id: number | null;
  usuario_email: string | null;
  accion: AccionAudit | string;
  entidad: string;
  entidad_id: number | null;
  metodo_http: string;
  path: string;
  status_code: number | null;
  ip: string | null;
  user_agent: string | null;
  ocurrido_en: string;
}

export interface AuditoriaFilters {
  usuario_id?: number;
  entidad?: string;
  accion?: AccionAudit;
  desde?: string; // ISO datetime
  hasta?: string;
  limit?: number;
}

export function listAuditoria(filters: AuditoriaFilters = {}): Promise<AuditoriaEntry[]> {
  const params = new URLSearchParams();
  if (filters.usuario_id) params.set("usuario_id", String(filters.usuario_id));
  if (filters.entidad) params.set("entidad", filters.entidad);
  if (filters.accion) params.set("accion", filters.accion);
  if (filters.desde) params.set("desde", filters.desde);
  if (filters.hasta) params.set("hasta", filters.hasta);
  params.set("limit", String(filters.limit ?? 200));
  const qs = params.toString();
  return apiFetch<AuditoriaEntry[]>(`/v1/auditoria${qs ? `?${qs}` : ""}`);
}
